var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('Carousel',{attrs:{"banners":_vm.banners}}),_c('Sobre'),_c('div',{staticClass:"container"},[_c('NavJobs')],1),_c('Expertises'),_c('Footer'),_c('back-to-top',{attrs:{"text":"Top"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }